import { useState } from "react";
import { Text1, Text2 } from "@components/ui/texts/Texts";
import { ChunkyTabs } from "@components/ui/selection/ChunkyTabs";
import EmailsSentScreen from "./EmailsSentScreen";
import { PushNotificationsSent } from "./settings/PushNotificationsSent";

type TabValue = "emails" | "push";

const TABS: { value: TabValue; label: string }[] = [
  { value: "emails", label: "Emails" },
  { value: "push", label: "Notifications push" },
];

export default function NotificationsScreen() {
  const [activeTab, setActiveTab] = useState<TabValue>("emails");

  return (
    <div className="flex flex-col overflow-auto max-h-screen">
      <div className="flex flex-col h-fit pb-96 mt-10 mx-4 lg:ml-10">
        <div className="flex flex-col w-full max-w-1k gap-4">
          {/* Page header */}
          <div className="flex flex-col">
            <Text1>Notifications</Text1>
            <Text2>
              Historique de tout ce qui a été envoyé aux clients et à
              l'équipe depuis Hexaflow.
            </Text2>
          </div>

          {/* Tabs */}
          <div>
            <ChunkyTabs
              tabs={TABS}
              activeTab={activeTab}
              setActiveTab={(v) => setActiveTab(v as TabValue)}
            />
          </div>

          {/* Tab content — render both mounted but hide the inactive one so
              their internal state (search, selection) survives tab switches. */}
          <div className={activeTab === "emails" ? "block" : "hidden"}>
            <EmailsSentScreen embedded />
          </div>
          <div className={activeTab === "push" ? "block" : "hidden"}>
            <PushNotificationsSent embedded />
          </div>
        </div>
      </div>
    </div>
  );
}
